var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.result)?_vm._t("default",null,{"result":_vm.result}):(_vm.error)?_vm._t("error",null,{"error":_vm.error}):(_vm.promise && !_vm.noLoading)?_vm._t("pending",function(){return [_c('loading')]}):_vm._e(),_vm._v(" "),(!_vm.promise)?_vm._t("noPromise"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }